import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle, CheckCircle, Lock } from 'lucide-react';
import CardInputFields from './CardInputFields';

export default function CardPaymentForm({
  finalTotal, paymentData, cardDetails, errors, processing,
  onFillTestCard, onCardChange, onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <div className="bg-green-50 border border-green-200 p-4 rounded-2xl flex items-center gap-3">
        <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
        <p className="text-sm text-green-900">
          <strong>Payment Initiated</strong> - Order ID: {paymentData?.pocket_pay_order_id?.substring(0, 8)}...
        </p>
      </div>

      {/* Test Card Helper */}
      <div className="bg-amber-50 border border-amber-200 p-3 rounded-xl">
        <div className="flex items-start gap-2 mb-2">
          <AlertCircle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-xs font-bold text-amber-900">TEST ENVIRONMENT</p>
            <p className="text-xs text-amber-700 mt-0.5">
              Use test card: 4444 5555 6666 7777 | CVV: 555 | Expiry: 01/35
            </p>
          </div>
        </div>
        <Button
          type="button"
          onClick={onFillTestCard}
          variant="outline"
          size="sm"
          className="w-full text-xs h-8 border-amber-300 hover:bg-amber-100"
        >
          Fill Test Card
        </Button>
      </div>

      <CardInputFields
        cardDetails={cardDetails}
        errors={errors}
        processing={processing}
        onChange={onCardChange}
      />

      {/* No Refund Policy - Informational */}
      <div className="bg-muted/30 border border-border p-3 rounded-xl">
        <p className="text-xs text-muted-foreground text-center leading-relaxed">
          <strong className="text-foreground">No Refund Policy:</strong> All sales are final. We do not offer refunds, exchanges, or cancellations once payment has been processed.
        </p>
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        disabled={processing}
        className="btn-volt w-full h-14 text-lg font-black"
        data-testid="process-payment-button"
      >
        {processing ? (
          <span className="flex items-center gap-2">
            <span className="animate-spin">⏳</span>
            Processing Payment...
          </span>
        ) : (
          `Pay $${finalTotal.toFixed(2)} BND`
        )}
      </Button>

      {/* Security Notice */}
      <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <Lock className="w-3 h-3" />
        <span>256-bit SSL encrypted payment</span>
      </div>
    </form>
  );
}
